import React from "react"
import { Toggle, Card, CardHeader, CardText } from "material-ui"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import * as  accountActions from "../../actions/AccountActions"
import { IHierarchyItemForAccountLevel, IHierarchyItem, IHierarchyItemSettings, IJobDocument } from "../../models"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
import AccountStore from "../../stores/AccountStore"
import AppStateStore from "../../stores/AppStateStore"
import _ from "lodash"
import HierarchyJobVariations from "./hierarchy_job_variations/HierarchyJobVariations"
import IVRNumberChip from "../common/IVRChipList/IVRNumberChip"

interface IProps {
    hierarchyJobItem: IHierarchyItemForAccountLevel | IHierarchyItem | IJobDocument
    inheritedHierarchyJobItem: IHierarchyItem | IJobDocument
    readonly: boolean
    handleUpdateJob(job: IJobDocument): Promise<void>
}
interface IState {
    expand: boolean
    isRoot: boolean
    canOverride: boolean
    ivrNumbers: string[]
}

export default class HierarchySettingsApprovedIVRNumbers extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            expand: false,
            isRoot: true,
            canOverride: false,
            ivrNumbers: [],
        }
        autobind(this)
    }

    componentDidMount() {
        this.checkIsRoot(this.props.hierarchyJobItem)
        this.getIvrNumbers(this.props.inheritedHierarchyJobItem)
    }

    componentWillReceiveProps(nextProps: IProps) {
        !_.isEqual(this.props.hierarchyJobItem, nextProps.hierarchyJobItem) &&
            this.checkIsRoot(nextProps.hierarchyJobItem)
        !_.isEqual(this.props.inheritedHierarchyJobItem, nextProps.inheritedHierarchyJobItem) &&
            this.getIvrNumbers(nextProps.inheritedHierarchyJobItem)
    }

    checkIsRoot(hierarchyJobItem: IHierarchyItemForAccountLevel | IHierarchyItem | IJobDocument) {
        hierarchyJobItem = hierarchyJobItem as IHierarchyItemForAccountLevel
        this.setState({ isRoot: hierarchyJobItem && hierarchyJobItem.level && hierarchyJobItem.level === -1 ? true : false }, () =>
            this.getCanOverride()
        )
    }

    getCanOverride() {
        if (!this.state.isRoot) {
            const hierarchyItem = this.props.hierarchyJobItem as (IHierarchyItem | IJobDocument)
            const inheritedHierarchyJobItemId = this.props.inheritedHierarchyJobItem ? this.props.inheritedHierarchyJobItem.Id : null
            this.setState({ canOverride: hierarchyItem.Id === inheritedHierarchyJobItemId })
        }
        else {
            this.setState({ canOverride: false })
        }
    }

    getIvrNumbers(inheritedHierarchyJobItem: (IHierarchyItem | IJobDocument)) {
        const hierarchySettings = inheritedHierarchyJobItem ?
            inheritedHierarchyJobItem.HierarchyItemSettings :
            AccountStore.getCurrentAccount().HierarchyItemSettings
        this.setState({ ivrNumbers: hierarchySettings.ApprovedIVRPhoneNumbers })
    }

    handleSave(canOverride: boolean, ivrNumbers: string[]) {
        const prevCanOverride = this.state.canOverride
        this.setState({ canOverride, ivrNumbers }, () => {
            if (prevCanOverride == true) {
                this.state.isRoot ?
                    this.updateAccountIVRNumbersSettings() :
                    this.updateHierarchyJobItemIVRNumberSettings()
            }
        })
    }

    updateAccountIVRNumbersSettings() {
        let hierarchyItemSettings = AccountStore.getCurrentAccount().HierarchyItemSettings
        if (hierarchyItemSettings) {
            hierarchyItemSettings.ApprovedIVRPhoneNumbers = this.state.ivrNumbers
        } else {
            hierarchyItemSettings = { ApprovedIVRPhoneNumbers: this.state.ivrNumbers } as IHierarchyItemSettings
        }
        accountActions.patchAccountHierarchySettings(AccountStore.getCurrentAccount().Id, { HierarchyItemSettings: hierarchyItemSettings })
    }

    updateHierarchyJobItemIVRNumberSettings() {
        const hierarchyJobItem = this.props.hierarchyJobItem as (IHierarchyItem | IJobDocument)
        if (this.state.canOverride) {
            if (hierarchyJobItem.HierarchyItemSettings) {
                hierarchyJobItem.HierarchyItemSettings.ApprovedIVRPhoneNumbers = this.state.ivrNumbers
            } else {
                hierarchyJobItem.HierarchyItemSettings = { ApprovedIVRPhoneNumbers: this.state.ivrNumbers } as IHierarchyItemSettings
            }
        } else {
            if (hierarchyJobItem.HierarchyItemSettings) {
                hierarchyJobItem.HierarchyItemSettings.ApprovedIVRPhoneNumbers = []
            } else {
                hierarchyJobItem.HierarchyItemSettings = { ApprovedIVRPhoneNumbers: [] } as IHierarchyItemSettings
            }
        }
        hierarchyJobItem.hasOwnProperty("AccountId") ?
            this.props.handleUpdateJob(hierarchyJobItem as IJobDocument).then(() => AppStateStore.setProgressSnackbarContent(null)) :
            accountActions.updateAccountHierarchyItem(AccountStore.getCurrentAccount().Id, hierarchyJobItem, true)
    }

    render() {
        let enablePunches = true
        if (this.props.hierarchyJobItem) {
            const hierarchyDefinition = hierarchyHelper.getHierarchyDefinitionByHierarchyItemId((this.props.hierarchyJobItem as IHierarchyItem).Id)
            if (hierarchyDefinition) {
                enablePunches = hierarchyDefinition.EnablePunches
            }
        }

        const editable = this.state.isRoot || this.state.canOverride
        const punchPermission = ((this.props.hierarchyJobItem as IHierarchyItemForAccountLevel).level && (this.props.hierarchyJobItem as IHierarchyItemForAccountLevel).level === -1) || enablePunches
        const readonly = this.props.readonly || !punchPermission

        return (
            <div>
                <Card
                    data-intercom-target={"menu-Hierarchy-Settings-ApprovedIPs"}
                    expanded={this.state.expand}
                    onExpandChange={expand => this.setState({ expand })}
                >
                    <CardHeader
                        title={"Approved IVR Phone Numbers"}
                        subtitle={[
                            <span key="title">
                                {this.state.isRoot ?
                                    `(${strings.not_inherited})` :
                                    !this.props.inheritedHierarchyJobItem ?
                                        `(${strings.formatString(strings.inherited_from_Account_x, AccountStore.getCurrentAccount().Name)})` :
                                        this.props.inheritedHierarchyJobItem.Id === (this.props.hierarchyJobItem as (IHierarchyItem | IJobDocument)).Id ?
                                            `(${strings.not_inherited})` :
                                            `(${strings.formatString(strings.inherited_from_x, `${hierarchyHelper.getHierarchyDefinitionByHierarchyItemId(this.props.inheritedHierarchyJobItem.Id).Label}:  ${(this.props.inheritedHierarchyJobItem as IHierarchyItem).Label}`)})`
                                }
                            </span>,
                            this.state.expand &&
                            <HierarchyJobVariations
                                key="hierarchy job variations"
                                settingPropertyName="ApprovedIVRPhoneNumbers"
                                hierarchyJobItem={this.props.hierarchyJobItem}
                                inheritedHierarchyJobItem={this.props.inheritedHierarchyJobItem}
                            />
                        ]}
                        actAsExpander
                        showExpandableButton
                        titleStyle={{ fontSize: 20, fontWeight: 500, display: "initial" }}
                        subtitleStyle={{ fontSize: 13, color: "rgb(97, 97, 97)", marginLeft: 10, display: "initial" }}
                    />
                    <CardText expandable>
                        {!this.state.isRoot &&
                            <Toggle
                                data-intercom-target={"menu-Hierarchy-Settings-ApprovedIPs-Toggle-Override"}
                                label={strings.Override}
                                style={{ marginBottom: 20, width: 300 }}
                                toggled={this.state.canOverride}
                                disabled={readonly}
                                onToggle={(e, canOverride) =>
                                    AppStateStore.setConfirmDialogContent({
                                        content: strings.Are_you_sure_you_want_to_change_this_setting_of_hierarchy,
                                        confirm: () => this.handleSave(canOverride, this.state.ivrNumbers)
                                    })
                                }
                            />
                        }
                        <IVRNumberChip
                            ivrNumbers={this.state.ivrNumbers}
                            readonly={readonly || !editable}
                            handleChange={ivrNumbers => this.handleSave(this.state.canOverride, ivrNumbers)}
                        />
                    </CardText>
                </Card >
            </div>
        )
    }
}